export default "<button class=\"button-secondary\">\n  <ion-label>button-secondary</ion-label>\n</button>";